import { Injectable } from '@angular/core';

import _set from 'lodash-es/set';
import _isString from 'lodash-es/isString';
import _find from 'lodash-es/find';
import _findIndex from 'lodash-es/findIndex';
import _unset from 'lodash-es/unset';
import _pullAt from 'lodash-es/pullAt';

//Lib Service
import { RoutingService } from "libraries/service/routing/routing.service";
import { TravellerService } from "libraries/service/traveller/traveller.service";
import { SelectService } from 'libraries/service/select/select.service';

import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";

declare var wenji: any;

@Injectable()
export class SynchronymeService {

    public data: any = {
        urlParams: {},
        tnr: 0,
        pnr: 0,
        sectorReference: {},//to be deleted
        travellerDiff: {},
        futureNamelists: []
    };

    //service vars
    private s_listData: any;

    constructor(
        private airRouting: RoutingService,
        private travellerService: TravellerService,
        private select: SelectService,
        private configurationService: ConfigurationResourceService
    ) {
        this.s_listData = select.data;
    }


    /**
     * storeReferenceRouting
     * get routing from sectors
     * call routingService.getRouting()
     */
    public storeReferenceRouting(_sector: any, _journey: any): void {
        _set(this.data, ['reference', 'sector'], _sector);
        _set(this.data, ['reference', 'journey'], _journey);
        if (!this.data.referenceRouting) {
            _set(this.data, 'referenceRouting', this.airRouting.getFullRouting(_sector, _journey));
        }
    }

    public isSameRouting(_sector: any, _journey: any): boolean {
        const newRouting = this.airRouting.getFullRouting(_sector, _journey);
        return this.airRouting.isSameRouting(this.data.referenceRouting, newRouting);
    }

    public storeThenCompareSector(_sector: any, _journey: any): boolean {

        //   this.storeSector( _sector );
        this.storeReferenceRouting(_sector, _journey);

        return this.isSameRouting(_sector, _journey);

    }

    public setFutureNameLists(journeys: any): any[] {
        const futureNameListsObject: any[] = this.data.futureNamelists;
        journeys.forEach((journey) => {
            futureNameListsObject.push({data: journey, done: false});
        });
        _set(this.data, 'futureNamelists', futureNameListsObject);
        return futureNameListsObject;
    }


    public setPnrNb(_quantity: number) {
        _set(this.data, 'pnr', _quantity);
        if (this.isAppEmpty()) {
            this.removeReferenceRouting();
        }
    }

    public setTnrNb(_quantity: number) {
        _set(this.data, 'tnr', _quantity);
        if (this.isAppEmpty()) {
            this.removeReferenceRouting();
        }
    }

    public isSameTraveller(_referenceTraveller: any, _newTraveller: any): boolean {
        return this.travellerService.isSameTraveller(_referenceTraveller, _newTraveller);
    }

    public getTravellerDifference(_referenceTraveller: any, _newTraveller: any): any {
        return this.travellerService.getTravellerDifference(_referenceTraveller, _newTraveller);
    }

    public isString(_value: any) {
        return _isString(_value);
    }

    public getNamelists() {
        return this.configurationService
                .get(['wui', 'config', 'namelist', 'nameList.json'], []);
    }

    /**
     * Compare journey (sector and journey properties)
     * if false, dont show the tnr/pnr
     * @param response
     */
    public hasSameJourney(response) {
        if(wenji.synchronyme.checkJourney){
            //get response sectors
            if(Array.isArray(response)){
                response = response[0];
            }
            const responseSector = response.sector;
            const responseJourney = response.journey;

            // Store response sectors and compare sectors
            return this.storeThenCompareSector(responseSector, responseJourney);
        }

        return true;
    }

    // TODO+LA : check how to change it now that we have a type
    public isTnrOnList(bookingCode, _type: string = null){
        return _find(this.data.tnrList, (o)=>o === bookingCode);
    }

    public addOnTnrList(idToAdd, tnr){
        if(!this.data.tnrList){
            this.data.tnrList = [];
        }
        this.data.tnrList.push(idToAdd);
        _set(this.data, ['tnrCollection', idToAdd], tnr);
    }

    public setBookingJourney(_journey: any){
        _set(this.data, 'bookingJourney', _journey);
    }

    public removeFromTnrList(idToRemove){
        const i = _findIndex(this.data.tnrList, (o)=>o === idToRemove);
        _pullAt(this.data.tnrList, i);
        _unset(this.data, ['tnrCollection', idToRemove]);
        // Removing journey found from first tnr midOfficeRef
        if(i === 0){
            _unset(this.data, 'bookingJourney');
        }
    }

    private isAppEmpty(): boolean {
        return this.data.tnr === 0 && this.data.pnr === 0;
    }

    private removeReferenceRouting(): void {
        _unset(this.data, 'referenceRouting');
    }

}
